// import Navbar from "./components/Navbar";
// import UseEffect from "./components/UseEffect";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Weapons from "./components/Weapons";
import Controls from "./components/Controls";
import Footer from "./components/Footer";

function App() {
    return (
      <>
        <Navbar/> 
        <Hero/> 
        <About/> 
        <Weapons/> 
        <Controls/> 
        <Footer/>
      </>

    )
}

export default App;